import React from 'react'
import { IS_MAC } from '../common/const'
import style from './kbar.module.scss'

const dotsFour = (
  <div className={`${style.dotsFour}`}>
    <div className={style.container}>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
    </div>
    <div className={style.container}>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
    </div>
    <div className={style.container}>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
    </div>
    <div className={style.container}>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
      <span className={style.dot}></span>
    </div>
  </div>
)

const dotsOne = (
  <div className={`${style.dotsOne}`}>
    <span className={style.dot}></span>
    <span className={style.dot}></span>
    <span className={style.dot}></span>
    <span className={style.dot}></span>
  </div>
)

const KEY_ICON_MAP = {
  mac: {
    alt: <i className={style.macOptionKey} />,
    ctrl: <i className={style.macCtrlKey} />,
    command: <i className={style.macCommandKey} />,
    shift: <i className={style.macShiftKey} />,
    cloning: <span className={style.kbarDotsContainer}>{dotsFour}</span>,
    clone: <span className={style.kbarDotsContainer}>{dotsOne}</span>
  },
  win: {
    cloning: <span className={style.kbarDotsContainer}>{dotsFour}</span>,
    clone: <span className={style.kbarDotsContainer}>{dotsOne}</span>
  }
}

type MacKey = keyof typeof KEY_ICON_MAP.mac
type WinKey = keyof typeof KEY_ICON_MAP.win

export function renderKey(key: string | React.ReactNode): React.ReactNode {
  if (typeof key !== 'string') return key

  if (IS_MAC && key.toLowerCase() in KEY_ICON_MAP.mac) {
    return KEY_ICON_MAP.mac[key.toLowerCase() as MacKey]
  } else if (!IS_MAC && key.toLowerCase() in KEY_ICON_MAP.win) {
    return KEY_ICON_MAP.win[key.toLowerCase() as WinKey]
  }

  return key
}
